<template>
  <AuthForm
    :can-submit="canBeSubmitted"
    :error="form.error"
    :submitted="form.submitted"
    type="group_size"
    @submit="submit"
  >
    <FormInput
      :label="$t('group_size')"
      :model-value="form.fields.group_size.value"
      name="group_size"
      type="tel"
      @update:modelValue="(newValue) => (form.fields.group_size = newValue)"
    />
  </AuthForm>
</template>

<script>
import AuthForm from '@/components/form/auth/AuthForm.vue'
import { FormInput } from '@/components/form/fields'
import { AuthFormCanBeSubmittedMixin } from '@/components/form/mixins'

export default {
  name: 'AuthOptionsForm',
  mixins: [AuthFormCanBeSubmittedMixin],
  components: { FormInput, AuthForm },
  data() {
    return {
      form: {
        error: null,
        fields: {
          group_size: {
            valid: false,
            value: null,
          },
        },
        submitted: false,
      },
    }
  },
  methods: {
    async submit() {
      this.form.error = null
      this.form.submitted = true
      const error = await this.$store.dispatch('updateHunter', {
        group_size: this.form.fields.group_size.value,
      })

      this.form.submitted = false
      this.form.error = error
    },
  },
  watch: {
    'form.fields.group_size.value'() {
      this.form.error = null
    },
  },
}
</script>
